var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9088 3.68221C11.487 4.10414 11.25 4.67634 11.25 5.27296C11.25 5.86958 11.487 6.44177 11.9088 6.86371L23.0463 18.0012L11.9088 29.1387C11.4989 29.5631 11.2721 30.1314 11.2773 30.7214C11.2824 31.3113 11.519 31.8756 11.9362 32.2928C12.3533 32.71 12.9177 32.9466 13.5076 32.9517C14.0976 32.9569 14.6659 32.7301 15.0903 32.3202L27.8185 19.592C28.2403 19.17 28.4773 18.5978 28.4773 18.0012C28.4773 17.4046 28.2403 16.8324 27.8185 16.4105L15.0903 3.68221C14.6683 3.2604 14.0961 3.02344 13.4995 3.02344C12.9029 3.02344 12.3307 3.2604 11.9088 3.68221Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.fe4dc8f12c6143a32c0d5ad87536de52.svg";
export { ForwardRef as ReactComponent };